<template>
    <button
        class="flex items-center px-3 py-2 rounded-lg transition duration-150 w-full font-semibold focus:outline-none focus:shadow-outline relative"
        :class="{
            'text-primary dark:text-primary-100 bg-primary-500 dark:bg-primary-600 bg-opacity-10': current,
            'text-gray-600 dark:text-gray-400': !current,
            'hover:bg-gray-100 dark-hover:bg-primary-600 hover:text-primary dark-hover:text-primary-100':
                !current && !disabled,
            'bg-gray-200 dark:bg-transparent': disabled,
        }"
        :disabled="disabled"
    >
        <slot name="icon" />

        <slot name="text" />

        <div
            v-if="comingSoon"
            style="font-size: 10px;"
            class="px-2 leading-loose bg-gray-100 dark:bg-gray-800 text-gray-600 border border-gray-400 rounded-lg uppercase absolute bottom-0 right-0 -m-2"
        >
            coming soon
        </div>
    </button>
</template>

<script>
export default {
    name: "MainSidebarButton",
    props: {
        current: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        comingSoon: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
svg {
    @apply w-5 h-5 mr-4;
}
</style>
